<template>
  <div class="modal fade" id="policiesModal" tabindex="-1" aria-labelledby="policiesModal" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div v-if="!loaded" class="modal-content">
        <div class="modal-header p-5">
          <h5 class="modal-title" id="policiesModalLabel">
            <template v-if="policyData">
              <span class="text-gray-600 fw-normal">№</span> {{ policyData.id ?? policyData.global_id}}
            </template>
            <template v-else>Ошибка</template>
          </h5>
          <div>
            <button
                type="button"
                class="btn btn-sm btn-light-primary me-5"
                @click="getFullInfo"
            >Обновить информацию
            </button>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
        <div class="modal-body p-5" v-if="policyData">
          <policy-actions :policy="policyData" :support-info="supportInfo" @toOgpo="toOgpo" @rescind="rescind" @dissolution="dissolution" @rejectSupport="rejectSupport"/>
          <policy-support-info v-if="supportInfo" :support-info="supportInfo" />
          <policy-info :policy="policyData" />
          <div class="mb-5">
            <div class="row">
              <div class="col-lg-6">
                <policy-insurer :insurer="policyData.insurer" />
                <policy-vehicle v-if="policyData.vehicles && policyData.vehicles.length" :vehicles="policyData.vehicles" />
                <policy-object v-if="policyData.object" :object="policyData.object" />
              </div>
              <div class="col-lg-6">
                <policy-insured v-if="policyData.insureds && policyData.insureds.length" :insureds="policyData.insureds" />
                <policy-beneficiary v-if="policyData.beneficiary" :beneficiary="policyData.beneficiary" />
              </div>
            </div>
          </div>
          <policy-documents v-if="(policyData.status === 1 || policyData.status === 7) && policyData.error === null && policyData.global_id" :policy="policyData" />
          <h5 v-if="policyData.error" class="text-gray-800 fw-bold mb-3">
            <span class="fw-bold text-danger" v-html="policyData.error_type"></span>
          </h5>
          <div class="p-4 rounded border" v-if="policyData.error">
            <pre class="mb-0" v-html="JSON.stringify(policyData.error, undefined, 1)"></pre>
          </div>
        </div>
        <div class="modal-footer p-2 justify-content-between">
          <button
              type="button"
              class="btn btn-sm btn-secondary"
              data-bs-dismiss="modal"
          >Закрыть
          </button>
        </div>
      </div>
      <div class="modal-content" v-else>
        <loader-full style="min-height: 323px"/>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import PolicyBeneficiary  from '@/components/Modals/Policy/ModalItems/PolicyBeneficiary'
import PolicyDocuments    from "@/components/Modals/Policy/ModalItems/PolicyDocuments.vue";
import PolicyInsurer      from '@/components/Modals/Policy/ModalItems/PolicyInsurer'
import PolicyInsured      from '@/components/Modals/Policy/ModalItems/PolicyInsured'
import PolicyVehicle      from '@/components/Modals/Policy/ModalItems/PolicyVehicle'
import PolicyActions      from '@/components/Modals/Policy/ModalItems/PolicyActions'
import PolicyObject       from '@/components/Modals/Policy/ModalItems/PolicyObject'
import PolicyInfo         from '@/components/Modals/Policy/ModalItems/PolicyInfo'
import PolicySupportInfo from "@/components/Modals/Policy/ModalItems/PolicySupportInfo.vue";
import LoaderFull from "@/components/Main/LoaderFull.vue";
import axios from "axios";

export default {
  name: 'PolicyModal',
  components: {
    LoaderFull, PolicySupportInfo, PolicyDocuments, PolicyActions, PolicyBeneficiary,
    PolicyInsurer, PolicyInsured, PolicyVehicle, PolicyObject, PolicyInfo
  },
  props: {
    policy: null,
    supportInfo: null,
    loading: null,
  },
  data () {
    return {
      loaded: false,
      policyData: null,
    }
  },
  methods: {
    getFullInfo() {
      this.loaded = true
      const headers  = {headers: {}, params: {one_c: this.policyData.id, noPaginate: true}}
      axios.get('/api/policy/all?page=1', headers)
          .then(res  => {
            if (res.data.length > 0) this.policyData = res.data[0]
          })
          .catch(err => { console.log(err) })
          .finally(() => {this.loaded = false})
    },
    toOgpo(isRewrite) {
      this.modalHidden()
      this.$router.push({name: 'Ogpo', query: {global:this.policy.global_id, isRewrite:isRewrite}})
    },
    modalHidden() {
      const myModalEl = document.getElementById('policiesModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      modal.hide();
    },
    rescind(data) {
      const rescind = {
        id:        data.id
      }
      this.$emit('rescind', rescind)
    },
    dissolution(data) {
      const dissolution = {
        global_id: data.global_id,
        resident:  data.insurer.resident,
        person:    data.insurer.person,
        hash:      data.insurer.hash,
      }
      this.$emit('dissolution', dissolution)
    },
    rejectSupport(data) {
      const rejectSupport = {
        id:        data.id
      }
      this.$emit('rejectSupport', rejectSupport)
    }
  },
  watch: {
    policy: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.policyData = newValue
          this.getFullInfo()
        }
      }
    },
    loading: {
      immediate: true,
      handler(newValue) {
        if (newValue) this.loaded = newValue
      }
    },
  }
}
</script>

<style scoped>
</style>